import { useNavigate } from 'react-router-dom'

import FormularioGasto from '../components/gastos/FormularioGasto'
import ModalMensaje from '../components/ui/ModalMensaje'
import { useEmpresa } from '../context/EmpresaContext'
import { useModalMensaje } from '../hooks/useModalMensaje'
import { supabase } from '../lib/supabase'
import { puedeCrearGastos } from '../utils/permisosGastos'

function NuevoGasto() {
  const navigate = useNavigate()
  const { empresaActual } = useEmpresa()
  const { modal, abrirModal, cerrarModal } = useModalMensaje()

  const guardarGasto = async (datosFormulario) => {
    const nuevoGasto = {
      ...datosFormulario,
      empresa_id: empresaActual.id,
      estado_registro: 'registrado',
    }

    const { error } = await supabase
      .from('gastos')
      .insert(nuevoGasto)

    if (error) {
      throw error
    }

    abrirModal({
      tipo: 'success',
      titulo: 'Gasto registrado',
      mensaje: 'El gasto fue registrado correctamente.',
      onAceptar: () => {
        cerrarModal()
        navigate('/gastos', { state: { recargar: true } })
      },
    })
  }

  if (!puedeCrearGastos(empresaActual?.rol)) {
    return (
      <div className="rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
        <h3 className="text-lg font-bold text-slate-900">
          Sin permisos
        </h3>

        <p className="mt-2 text-slate-500">
          Tu perfil no tiene permisos para registrar gastos.
        </p>
      </div>
    )
  }

  return (
    <>
      <FormularioGasto
        modo="crear"
        onGuardar={guardarGasto}
        onCancelar={() => navigate('/gastos')}
      />

      <ModalMensaje {...modal} />
    </>
  )
}

export default NuevoGasto
